import React from 'react'
import { Col, Row } from 'reactstrap'

const AboutProfessionalLabTesting = () => {
  return (
    <div id='website-responsive'>
        <div className='bg-img left-padding5rem1 right-padding5rem1 pemd-5 py-lg-5 py-4 p-topbottom2rem' style={{ }}>
            <Row className='reverse-section pt-md-3'>
            <Col sm='12' md='12' lg='5' className='flex-center'>
                    <div className='flex-center mt-md-0 mt-'>
                        <img className='img-w5' src='about-us/About-Us-img2-v1.webp' alt='pic' height='auto' width='%' />
                    </div>
                </Col>

                <Col sm='12' md='12' lg='7' className='pe-md5 pt-md-4'>
                    <div className=''>
                        <div className=''>
                            <h2 className='fw-700 fs-ss-32 text-ss-primary text-montserrat'>
                                PROFESSIONAL LAB TESTING SERVICES
                            </h2>
                            <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                        </div>

                        <div className='pt-3'>
                            <p className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                            United Lab Care is committed to helping patients get their lab tests easily and quickly by providing world-class lab testing solutions under one roof.
                            </p>
                        </div>

                        <div className='pt-3'>
                            <p className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                            We employ an innovative method of using tools and technologies. This sense of accountability also means we give extra care and value and promote seamless interaction with our clients. We strive to adapt to change and continuously improve our lab testing services.
                            </p>
                        </div>

                        <div className='pt-3'>
                            <p className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                            With the aid of our well-established and advanced infrastructural unit, we can provide the best quality array of products and services. Our lab is outfitted with all the necessary tools and machinery, and this infrastructural unit helps us deliver these products per the client’s demands.
                            </p>
                        </div>

                    </div>
                </Col>

                

                
            </Row>
        </div>
    </div>
  )
}

export default AboutProfessionalLabTesting